import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import WithNavigationBarLayout from "src/components/WithNavigationBarLayout";
import { H2, BodyText } from "src/atoms/typography";
import IconOnBackgound from "src/components/IconOnBackground";
import ScrollBox from "src/atoms/ScrollBox";
import AsParagraphs from "src/components/AsParagraphs";

import { ReactComponent as DescriptionIcon } from "./description.svg";

export default function ActivityLogDescription({ onClose, onBack }) {
  const { t } = useTranslation();

  return (
    <WithNavigationBarLayout
      navigationBarProps={{
        onClose,
        onBack
      }}
      childrenBoxProps={{
        pt: "16px",
        pb: "max(16px, min(60px,calc(10vh - 34px)))"
      }}
    >
      <ScrollBox height="100%">
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="320px"
          mx="auto"
          minHeight="100%"
        >
          <IconOnBackgound
            icon={DescriptionIcon}
            bg="primaryLight"
            fill="primary"
            iconSize="24px"
            size="40px"
          />
          <H2 color="highEmphasis" textAlign="center" mt="16px">
            {t("activityLog.description.heading")}
          </H2>
          <AsParagraphs
            mt="12px"
            Component={(props) => (
              <BodyText color="mediumEmphasis" textAlign="center" {...props} />
            )}
            spacing="8px"
          >
            {t("activityLog.description.text")}
          </AsParagraphs>
        </Flex>
      </ScrollBox>
    </WithNavigationBarLayout>
  );
}
